(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guarantees-carousel"] && !Shopify.designMode) return;
  try {
    
class GuaranteesCarouselScroller extends HTMLElement {
  connectedCallback() {
    this.originals = Array.from(this.children).filter(function (el) {
      return el.classList.contains('guarantees-carousel__card');
    });
    if (this.originals.length < 1) return;

    this.wrapper = this.closest('.guarantees-carousel');
    this.dots = this.wrapper ? Array.from(this.wrapper.querySelectorAll('.guarantees-carousel__dot')) : [];
    this.activeIndex = 0;
    this.autoplayEnabled = this.dataset.autoplay === 'true' && this.originals.length > 1;
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.cloneSets();
    this.setWidth = this.measureSetWidth();
    this.scrollLeft = this.setWidth;

    this.handleSettle = this.handleSettle.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.pauseAutoplay = this.pauseAutoplay.bind(this);
    this.scheduleResume = this.scheduleResume.bind(this);

    if ('onscrollend' in window) {
      this.addEventListener('scrollend', this.handleSettle, { passive: true });
    } else {
      this.addEventListener(
        'scroll',
        function () {
          clearTimeout(this._settleTimer);
          this._settleTimer = setTimeout(this.handleSettle, 100);
        }.bind(this),
        { passive: true }
      );
    }

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(this.handleResize, 150);
      }.bind(this)
    );

    this.addEventListener('pointerdown', this.pauseAutoplay, { passive: true });
    this.addEventListener('pointerup', this.scheduleResume, { passive: true });
    this.addEventListener('mouseenter', this.pauseAutoplay, { passive: true });
    this.addEventListener('mouseleave', this.scheduleResume, { passive: true });

    this.dots.forEach(
      function (dot, i) {
        dot.addEventListener('click', function () {
          this.pauseAutoplay();
          this.scrollToIndex(i);
          this.scheduleResume();
        }.bind(this));
      }.bind(this)
    );

    this.updateActiveDot();
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.pauseAutoplay();
  }

  cloneSets() {
    var makeSet = function (originals) {
      return originals.map(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[tabindex]').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        Array.from(clone.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
        });
        return clone;
      });
    };

    var before = makeSet(this.originals);
    var after = makeSet(this.originals);
    var firstCard = this.originals[0];
    before.forEach(
      function (clone) {
        this.insertBefore(clone, firstCard);
      }.bind(this)
    );
    after.forEach(
      function (clone) {
        this.appendChild(clone);
      }.bind(this)
    );
  }

  measureSetWidth() {
    var gap = parseFloat(getComputedStyle(this).columnGap) || 0;
    return (
      this.originals.reduce(function (sum, card) {
        return sum + card.getBoundingClientRect().width;
      }, 0) +
      gap * this.originals.length
    );
  }

  cardTargetScrollLeft(card) {
    return card.getBoundingClientRect().left - this.getBoundingClientRect().left + this.scrollLeft;
  }

  scrollToIndex(index, smooth) {
    var card = this.originals[index];
    if (!card) return;
    this.scrollTo({ left: this.cardTargetScrollLeft(card), behavior: smooth === false ? 'auto' : 'smooth' });
  }

  nearestIndex() {
    var closestIndex = 0;
    var closestDist = Infinity;
    this.originals.forEach(
      function (card, i) {
        var dist = Math.abs(this.cardTargetScrollLeft(card) - this.scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      }.bind(this)
    );
    return closestIndex;
  }

  updateActiveDot() {
    this.dots.forEach(function (dot, i) {
      var active = i === this.activeIndex;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    }.bind(this));
  }

  handleSettle() {
    if (this.scrollLeft < this.setWidth) {
      this.scrollLeft += this.setWidth;
    } else if (this.scrollLeft >= this.setWidth * 2) {
      this.scrollLeft -= this.setWidth;
    }
    this.activeIndex = this.nearestIndex();
    this.updateActiveDot();
  }

  handleResize() {
    this.setWidth = this.measureSetWidth();
    this.scrollToIndex(this.activeIndex, false);
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.reducedMotion) return;
    this.stopAutoplay();
    this._autoplayTimer = setInterval(
      function () {
        var next = (this.activeIndex + 1) % this.originals.length;
        this.scrollToIndex(next);
      }.bind(this),
      this.autoplaySpeed
    );
  }

  stopAutoplay() {
    clearInterval(this._autoplayTimer);
  }

  pauseAutoplay() {
    clearTimeout(this._resumeTimer);
    this.stopAutoplay();
  }

  scheduleResume() {
    clearTimeout(this._resumeTimer);
    this._resumeTimer = setTimeout(this.startAutoplay.bind(this), 4000);
  }
}

if (!customElements.get('guarantees-carousel-scroller')) {
  customElements.define('guarantees-carousel-scroller', GuaranteesCarouselScroller);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
class ReviewsCarouselScroller extends HTMLElement {
  connectedCallback() {
    this.originals = Array.from(this.children).filter(function (el) {
      return el.classList.contains('reviews-carousel__card');
    });
    if (this.originals.length < 1) return;

    this.cloneSets();
    this.setWidth = this.measureSetWidth();
    this.scrollLeft = this.setWidth;

    this.handleSettle = this.handleSettle.bind(this);
    this.handleResize = this.handleResize.bind(this);

    if ('onscrollend' in window) {
      this.addEventListener('scrollend', this.handleSettle, { passive: true });
    } else {
      this.addEventListener(
        'scroll',
        function () {
          clearTimeout(this._settleTimer);
          this._settleTimer = setTimeout(this.handleSettle, 100);
        }.bind(this),
        { passive: true }
      );
    }

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(this.handleResize, 150);
      }.bind(this)
    );
  }

  cloneSets() {
    var makeSet = function (originals) {
      return originals.map(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[tabindex]').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        Array.from(clone.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
        });
        return clone;
      });
    };

    var before = makeSet(this.originals);
    var after = makeSet(this.originals);
    var firstCard = this.originals[0];
    before.forEach(
      function (clone) {
        this.insertBefore(clone, firstCard);
      }.bind(this)
    );
    after.forEach(
      function (clone) {
        this.appendChild(clone);
      }.bind(this)
    );
  }

  measureSetWidth() {
    var gap = parseFloat(getComputedStyle(this).columnGap) || 0;
    return (
      this.originals.reduce(function (sum, card) {
        return sum + card.getBoundingClientRect().width;
      }, 0) +
      gap * this.originals.length
    );
  }

  handleSettle() {
    if (this.scrollLeft < this.setWidth) {
      this.scrollLeft += this.setWidth;
    } else if (this.scrollLeft >= this.setWidth * 2) {
      this.scrollLeft -= this.setWidth;
    }
  }

  handleResize() {
    this.setWidth = this.measureSetWidth();
    this.scrollLeft = this.setWidth;
  }
}

if (!customElements.get('reviews-carousel-scroller')) {
  customElements.define('reviews-carousel-scroller', ReviewsCarouselScroller);
}

  } catch(e) { console.error(e); }
})();
})();
